// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1EC1z","footer":"ModalUpdate_footer__1zzwA"};